import { FC } from 'react';

interface ResultBannersProps {
  cancelResult: string | null;
  additionalResult: string | null;
  disposeResult: string | null;
  refundResult?: string | null;
}

export const ResultBanners: FC<ResultBannersProps> = ({
  cancelResult,
  additionalResult,
  disposeResult,
  refundResult,
}) => {
  return (
    <>
      {cancelResult && (
        <div
          className={`mx-4 mb-2 rounded-lg px-4 py-2.5 text-sm font-medium ${
            cancelResult.startsWith('오류')
              ? 'bg-red-50 text-red-700'
              : 'bg-green-50 text-green-700'
          }`}
        >
          {cancelResult}
        </div>
      )}
      {additionalResult && (
        <div
          className={`mx-4 mb-2 rounded-lg px-4 py-2.5 text-sm font-medium ${
            additionalResult.startsWith('오류')
              ? 'bg-red-50 text-red-700'
              : 'bg-green-50 text-green-700'
          }`}
        >
          {additionalResult}
        </div>
      )}
      {disposeResult && (
        <div
          className={`mx-4 mb-2 rounded-lg px-4 py-2.5 text-sm font-medium ${
            disposeResult.startsWith('오류')
              ? 'bg-red-50 text-red-700'
              : 'bg-green-50 text-green-700'
          }`}
        >
          {disposeResult}
        </div>
      )}
      {refundResult && (
        <div
          className={`mx-4 mb-2 rounded-lg px-4 py-2.5 text-sm font-medium ${
            refundResult.startsWith('오류')
              ? 'bg-red-50 text-red-700'
              : 'bg-green-50 text-green-700'
          }`}
        >
          {refundResult}
        </div>
      )}
    </>
  );
};
